import { DateTime } from 'luxon'
import React from 'react'
import Text from '../../../../components/atoms/text/Text'
import { terms } from '../../../../config'
import { useHolidays } from '../../../../modules/seats/hooks'
import styles from './Timetable.module.css'

const Timetable = () => {
  const { data: holidays } = useHolidays()

  const holidaysString = holidays.map((festivo) => DateTime.fromJSDate(festivo).toFormat('dd MMM'))
  const holidaysStringFormatted = holidaysString.join(' / ')
  return (
    <>
      <section className={styles.container}>
        <Text weight="500" size="xl" align="center" transform="uppercase" className={styles.title}>
          Horario del coworking
        </Text>

        <article className={styles.grid}>
          <div className={styles.timetableBlock}>
            <Text weight="600" size="xl" align="center">
              8:00<span className={styles.super}>AM</span> - 21:00<span className={styles.super}>PM</span>
            </Text>

            <Text size="m" align="center" transform="uppercase">
              Lunes a Viernes
            </Text>
          </div>

          <div className={styles.timetableBlock}>
            <Text weight="600" size="xl" align="center">
              8:00<span className={styles.super}>AM</span> - 14:30<span className={styles.super}>PM</span>
            </Text>

            <Text size="m" align="center" transform="uppercase">
              Jornada de mañana
            </Text>
          </div>

          <div className={styles.timetableBlock}>
            <Text weight="600" size="xl" align="center">
              15:00<span className={styles.super}>PM</span> - 21:00<span className={styles.super}>PM</span>
            </Text>

            <Text size="m" align="center" transform="uppercase">
              Jornada de tarde
            </Text>
          </div>
        </article>

        <article className={styles.disclaimers}>
          <Text align="center">
            El Coworking{' '}
            <Text weight="600" element="b">
              abrirá sus puertas con normalidad durante el mes de Agosto
            </Text>
            .
          </Text>

          <Text align="center">
            Los{' '}
            <Text weight="600" element="b">
              {`festivos nacionales de ${holidays[0] ? holidays[0].getFullYear() : new Date().getFullYear()}`}
            </Text>
            {', '}
            el Coworking permacerá{' '}
            <Text weight="600" element="b">
              cerrado al público:
            </Text>
          </Text>

          <Text align="center" transform="capitalize">
            {holidaysStringFormatted}
          </Text>
        </article>

        <div>
          <a className={styles.button} href={terms} rel="noreferrer" target="_blank">
            Consulta la normativa
          </a>
        </div>
      </section>
    </>
  )
}

export default React.memo(Timetable)
